import React, { useEffect, useState } from "react";
import GuideSection from "../components/guide/GuideSection";
import { legalFormsGuide } from "../components/guide/guideContent";
import { formatPrice } from "../utils/formatPrice";
import { Card, OverlayTrigger, Tooltip } from "react-bootstrap";
import Header from "../components/header/Header";
import ProgressBar from "../components/progressBar/ProgressBar";
import { useNavigate } from "react-router-dom";
import { useDispatch, useSelector } from "react-redux";
import { addToCart } from "../redux/actions/CartActions";
import pricing from "../assets/data/pricing.json";
import { createBusinessRequest } from "../redux/actions/RequestActions";
import Swal from "sweetalert2";
import Loader from "../components/loader/Loader";
import ReactTooltip from "react-tooltip";
import typesEntreprises from "../assets/data/typesEntreprises.json";
import "./styles/business-type.css";
import {
  creationPrice,
  isAssociation,
  procedureFor,
} from "../utils/creationFlow";

function BusinessType() {
  const navigate = useNavigate();
  const dispatch = useDispatch();
  const currentStep = "Entreprise";
  const steps = [
    "Propriétaire",
    "Entreprise",
    "Services",
    "Paiement",
    "Finalisation",
  ];
  const cart = useSelector((state) => state.cart);
  const { user } = useSelector((state) => state.authUser);
  const [submitting, setSubmitting] = useState(false);

  useEffect(() => {
    window.scrollTo({ top: 0, behavior: "smooth" });
  }, []);

  const handleAddToCart = async (value) => {
    setSubmitting(true);
    // Keeps the chosen procedure when it is offered for the new type
    const procedure = procedureFor(value, cart.procedure);

    if (cart.from === "creation") {
      await dispatch(
        addToCart({
          procedure,
          creation: {
            businessType: value,
            amount: creationPrice(value, procedure),
          },
        }),
      );
    }

    await dispatch(
      addToCart({
        businessType: value,
      }),
    );

    if (cart.from === "creation") {
      await dispatch(
        createBusinessRequest(
          user.token,
          { country: cart.businessCountry, businessType: value, procedure },
          (response) => handleCallback(response, value),
        ),
      );
    } else {
      navigate(`/sector-activity`);
    }
  };

  const handleCallback = ({ success, message }, value) => {
    const selectedType = typesEntreprises.find(
      (typeEntreprise) => typeEntreprise.name === value,
    );
    const Toast = Swal.mixin({
      toast: true,
      position: "top-end",
      showConfirmButton: false,
      timer: 4000,
    });
    if (success) {
      if (cart.from === "creation" && isAssociation(value)) {
        navigate(`/manager-type`);
      } else if (
        selectedType &&
        selectedType.canCreateWithPartners &&
        cart.from === "creation"
      ) {
        navigate(`/associated-creators`);
      } else {
        navigate(`/sector-activity`);
      }
    } else {
      Toast.fire({
        icon: "error",
        title: "Échec",
        text: message,
      });
    }
    setSubmitting(false);
  };

  return (
    <div style={{ backgroundColor: "#fff" }}>
      <Header />
      <Loader isLoading={submitting} />
      <ProgressBar steps={steps} currentStep={currentStep} />

      <>
        <div className="container my-4">
          {cart.from === "creation" ? (
            <h4 className="text-center mt-4 mb-4">
              Quel <span style={{ color: "#FF5500" }}>type</span> d'entreprise
              souhaitez-vous créer ?
            </h4>
          ) : cart.from === "domiciliation" ? (
            <h4 className="text-center  mt-4 mb-4">
              Quel <span style={{ color: "#FF5500" }}>type</span> d'entreprise
              souhaitez-vous domicilier ?
            </h4>
          ) : cart.from === "management" ? (
            <h4 className="text-center  mt-4 mb-4">
              Quel <span style={{ color: "#FF5500" }}>type</span> d'entreprise
              souhaitez-vous gérer ?
            </h4>
          ) : (
            <h4 className="text-center  mt-4 mb-4">
              Quel est le <span style={{ color: "#FF5500" }}>type</span> de
              votre entreprise ?
            </h4>
          )}
          <div className="business-type-grid">
            {typesEntreprises
              .filter((type) => {
                if (cart.from === "creation") {
                  return ["ETS", "SARL", "SARLU", "ASSOCIATION"].includes(
                    type.name,
                  );
                }
                return true;
              })
              .map((type, index) => (
                <div key={index}>
                  <OverlayTrigger
                    placement="bottom"
                    color="#FF5500"
                    overlay={
                      <Tooltip id={`tooltip-${index}`}>
                        {type.description}
                      </Tooltip>
                    }
                  >
                    <Card
                      style={{
                        height: "100px",
                        cursor: "pointer",
                        transition: "0.3s",
                        boxShadow: "0 4px 8px rgba(0, 0, 0, 0.1)",
                        borderRadius: "8px",
                        textAlign: "center",
                        border:
                          cart.businessType === type.name
                            ? "2px solid #FF5500"
                            : "2px solid transparent",
                      }}
                      className="p-2"
                      onMouseEnter={(e) => {
                        e.currentTarget.style.boxShadow =
                          "0 8px 16px rgba(0, 0, 0, 0.2)";
                        e.currentTarget.style.borderColor = "#FF5500";
                      }}
                      onMouseLeave={(e) => {
                        e.currentTarget.style.boxShadow =
                          "0 4px 8px rgba(0, 0, 0, 0.1)";
                        e.currentTarget.style.borderColor =
                          cart.businessType === type.name
                            ? "#FF5500"
                            : "transparent";
                      }}
                      onClick={() => handleAddToCart(type.name)}
                    >
                      <Card.Body className="d-flex flex-column justify-content-center align-items-center">
                        <Card.Title
                          style={{ fontSize: "1rem", fontWeight: 500 }}
                        >
                          {type.name}
                        </Card.Title>
                        {cart.from === "creation" && (
                          <span
                            style={{
                              fontSize: "1rem",
                              borderRadius: "5px",
                              color: "#FF5500",
                            }}
                          >
                            {formatPrice(pricing.creation[type.name])}
                          </span>
                        )}
                      </Card.Body>
                    </Card>
                  </OverlayTrigger>
                </div>
              ))}
          </div>
        </div>
        {cart.from === "creation" && <GuideSection {...legalFormsGuide} />}
        <ReactTooltip place="top" type="dark" effect="solid" />
      </>
    </div>
  );
}

export default BusinessType;
